import { render, staticRenderFns } from "./ubicacion.vue?vue&type=template&id=43b867c8"
import script from "./ubicacion.vue?vue&type=script&lang=js"
export * from "./ubicacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports